import { Route, Routes } from 'react-router';
import PasswordResetCheck from 'pages/password-reset/check';
import PasswordResetSuccess from 'pages/password-reset/success';
import PasswordResetUpdate from 'pages/password-reset/update';
import PasswordReset from 'pages/password-reset';
import { FunctionComponent } from 'react';

const PasswordResetRoutes: FunctionComponent = () => {
  return (
    <Routes>
      <Route path="/*" element={<PasswordReset />} />
      <Route path="/check" element={<PasswordResetCheck />} />
      <Route path="/success" element={<PasswordResetSuccess />} />
      <Route path="/:token" element={<PasswordResetUpdate />} />
    </Routes>
  );
};

export default PasswordResetRoutes;
